import { render, staticRenderFns } from "./projectDetails.vue?vue&type=template&id=61c25586&scoped=true"
import script from "./projectDetails.vue?vue&type=script&lang=js"
export * from "./projectDetails.vue?vue&type=script&lang=js"
import style0 from "./projectDetails.vue?vue&type=style&index=0&id=61c25586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c25586",
  null
  
)

export default component.exports